export const australia = {
  slug: "australia",
  name: "Australia",
  flag: "🇦🇺",
  tagline: "Top-Ranked Universities, Sun, and a Future",
  heroImg: "https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=1600&auto=format&fit=crop",
  accentColor: "#1A3A5C",
  students: "190+",
  avgTuition: "AUD $20,000–$45,000/yr",
  avgLiving: "AUD $1,500–$2,500/mo",
  workPermit: "2–4 years post-study (Subclass 485)",
  ieltsReq: "6.0–7.5",
  intakeMonths: ["February", "July"],
  overview:
    "Australia has 7 universities in the global top 100, and its Temporary Graduate Visa (Subclass 485) offers 2–4 years of open post-study work rights. The relaxed lifestyle, world-class research facilities, and clear PR pathway make it the complete package for ambitious students.",
  whyChoose: [
    { icon: "🌅", title: "World Top-100 Universities", desc: "7 universities in global top 100 — Melbourne, ANU, Sydney, UNSW, Monash, UQ, and Adelaide." },
    { icon: "⏳", title: "2–4 Year Grad Visa", desc: "Temporary Graduate Visa gives up to 4 years post-study work rights depending on institution and location." },
    { icon: "🌊", title: "Lifestyle & Safety", desc: "Consistently ranked globally for safety, happiness, and liveability — plus extraordinary natural beauty." },
    { icon: "💼", title: "Unlimited Work Rights", desc: "No cap on working hours (changed in 2023) — earn while you learn without restrictions." },
    { icon: "🔬", title: "Research Powerhouse", desc: "World-leading research in AI, biotech, and environmental science — excellent for PhD pathways." },
    { icon: "🤝", title: "Large Indian Community", desc: "3rd largest Indian diaspora globally — community support, cultural familiarity, and strong networks." },
  ],
  process: [
    { step: "01", title: "University Selection", desc: "We identify Group of Eight vs. other universities based on your course, budget, and PR strategy." },
    { step: "02", title: "Application & Offer", desc: "Complete applications, English proficiency scores, and academic transcripts submitted correctly first time." },
    { step: "03", title: "Student Visa (Subclass 500)", desc: "GTE statement, Genuine Student requirement, OSHC health insurance — we make the visa watertight." },
    { step: "04", title: "Arrival Support", desc: "Accommodation, TFN, Medicare, Australian banking — orientation so you're productive from day one." },
  ],
  universities: [
    "university-of-melbourne", "university-of-sydney", "anu", "unsw",
    "university-of-queensland", "monash-university", "university-of-western-australia", "university-of-adelaide",
    "university-of-technology-sydney", "rmit-university", "deakin-university", "la-trobe-university",
    "swinburne-university", "griffith-university", "james-cook-university", "curtin-university",
    "murdoch-university", "macquarie-university", "western-sydney-university", "university-of-newcastle",
    "university-of-wollongong", "charles-sturt-university", "victoria-university", "flinders-university",
    "bond-university",
  ],
  stats: [
    { n: "190+", label: "Students Placed" },
    { n: "4yr",  label: "Max Post-Study" },
    { n: "97%",  label: "Visa Success" },
    { n: "7",    label: "Top-100 Unis" },
  ],
};
